import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../oppgaver/Oppgaver.module.css";
import wstyles from "./Widgets.module.css";
import { apen, endre, forfalt, hentMine, mineFraMinnet, minRolle, sorter, type Meg, type Oppgave } from "../../lib/oppgaver";
import { FaseMerke, FristTekst } from "../oppgaver/felles";

/** Mine oppgaver på Hjem (der Mine prosjekter var): de åpne, nærmeste frist først. */
export function MineOppgaver() {
  const [data, setData] = useState<{ meg: Meg; oppgaver: Oppgave[] } | null>(mineFraMinnet);
  const [feil, setFeil] = useState<string | null>(null);
  const navigate = useNavigate();
  const last = useCallback(() => {
    hentMine().then(setData).catch((e: Error) => setFeil(e.message));
  }, []);
  useEffect(() => { last(); }, [last]);

  if (feil) return <p className={wstyles.muted}>{feil}</p>;
  if (!data) return <p className={wstyles.muted}>Henter oppgaver …</p>;
  const apne = data.oppgaver.filter(apen).sort(sorter);
  const antallForfalt = apne.filter((o) => forfalt(o)).length;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, height: "100%" }}>
      <span className={styles.teller}>{apne.length} åpne{antallForfalt ? ` · ${antallForfalt} forfalt` : ""}</span>
      {apne.length === 0 ? (
        <p className={wstyles.muted}>Ingen åpne oppgaver. Godt jobbet!</p>
      ) : (
        <ul className={styles.mini} style={{ overflowY: "auto", flex: 1 }}>
          {apne.slice(0, 8).map((o) => (
            <li key={o.id}>
              <input
                className={styles.hake}
                type="checkbox"
                aria-label={`Marker som fullført: ${o.tittel}`}
                onChange={async () => {
                  try {
                    await endre(o.id, { status: "Fullført" });
                  } finally {
                    last();
                  }
                }}
              />
              <button className={styles.tekstknapp} type="button" onClick={() => navigate(`/oppgaver?oppgave=${o.id}`)}>
                <span className={styles.tittel}>{o.tittel}</span>
                <span className={styles.meta}>
                  <span>{o.prosjekt}</span>
                  <FaseMerke kode={o.faseKode} navn={o.fase} />
                  <FristTekst o={o} />
                  {minRolle(o, data.meg) === "ansvarlig" ? <span className={styles.chipAkt}>Ansvarlig</span> : <span className={styles.chipGitt}>Deltaker</span>}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
      <button className={styles.lenke} type="button" onClick={() => navigate("/oppgaver")}>Se alle oppgaver →</button>
    </div>
  );
}
